export default "__VITE_ASSET__B$muoQyI__"